import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; //   npm i react-router-dom
import CryptoJS from "crypto-js";
import { GetTokenbyTrade, CreatePayment } from "../../api/order";
import Image from "../../components/common/Image";
import Invoice from "../../components/service/fee/Invoice";

export default function Payment({ data, Token, setModal, setStep }) {
  const navigate = useNavigate();
  let Version = "V2";
  let language = window.ECPay.Language.zhTW;
  const [paymentRendered, setPaymentRendered] = useState(false);
  // const [Token, setToken] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [PayToken, setPayToken] = useState("");
  const [invoiceData, setInvoiceData] = useState({
    type: { id: 1, name: "個人發票" }
  })
  const [invoiceModal, setInvoiceModal] = useState(null)
  // const [ThreeDURL, setThreeDURL] = useState("");
  // const [UnionPayURL, setUnionPayURL] = useState("");

  useEffect(() => {
    const Timestamp = Math.floor(Date.now() / 1000)

    // GetTokenbyTrade({
    //   totalAmount: 2000,
    //   orderID: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // }).then((res) => {
    //   if (res?.statusCode === 200) {
    //     // console.log(res)
    //     setToken(res.result);
    //   }
    // });
  }, []);
  useEffect(() => {
    if (Token) {
      if (!window.ECPayInitialized) {
        let type = process.env.REACT_APP__ENV ==='production'?'Prod':'Stage'
        window.ECPay.initialize(type, 1, function (errMsg) {
          if (errMsg) {
            console.error(errMsg);
          } else {
            window.ECPay.createPayment(
              Token.token,
              window.ECPay.Language.zhTW,
              function (errMsg) {
                if (errMsg) {
                  console.error(errMsg);
                } else {
                  setPaymentRendered(true);
                  window.ECPayInitialized = true; // 標記為已初始化
                }
              },
              Version
            );
          }
        });
      } else {
        // 如果已經初始化，直接呼叫 createPayment
        window.ECPay.createPayment(
          Token.token,
          window.ECPay.Language.zhTW,
          function (errMsg) {
            if (errMsg) {
              console.error(errMsg);
            } else {
              setPaymentRendered(true);
            }
          },
          Version
        );
      }
    }
  }, [Token]);

  //等待取得 Paytoken
  useEffect(() => {

  }, [data]); //useCallback 尚待解決

  //等待取得 ThreeDURL
  // useEffect(() => {
  //   if (ThreeDURL) {
  //     window.location.href = ThreeDURL.replace(/^"|"$/g, "");
  //   } else if (UnionPayURL) {
  //     window.location.href = UnionPayURL.replace(/^"|"$/g, "");
  //   }
  // }, [ThreeDURL, UnionPayURL]);
  const handleGetPayToken = async () => {
    window.ECPay.getPayToken(function (paymentInfo, errMsg) {
      if (errMsg) {
        console.error(errMsg);
        return;
      }
      setIsClicked(true);
      CreatePayment({
        merchantTradeNo: paymentInfo.MerchantTradeNo,
        payToken: paymentInfo.PayToken,
        issue: { ...invoiceData, type: invoiceData.type.id, orderId: data.orderId }
      }).then(res => {
        if (res?.statusCode === 200) {
          if (res.result.threeDURL) window.open(res.result.threeDURL, "_self");
        }
      })
    });
  }

  return (
    <div className="grid-gap-24">
      <div className="page-header">
        <button className="btn-circle" onClick={() => setStep(1)}>
          <Image src="/images/icons/close.svg" svg />
        </button>
        <div className="page_header__title">
          <h1 className="font-heading">線上刷卡</h1>
        </div>
      </div>
      {/* <div className="flex flex-col items-top justify-center"> */}
      <div className="confirm-block" style={{ marginTop: 0, flexGrow: "unset" }}>
        <div className="block">
          <div className="list_block info_block">
            <div className="desc_flex">
              <Image src="/images/icons/dollar.svg" />
              <div className="title_block">
                <p className="title">{
                  data.status === 99 ? data.cancelAmount :
                    data.amount ? data.amount : data.preBillAmount
                }</p>
                <p className="text">
                  {
                    data.status === 99 ? "取消金額" : data.amount ? "服務費用" : "試算金額"
                  }
                </p>
              </div>
            </div>
            {
              data.status !== 99 && (
                <div
                  onClick={() => setModal({ type: "fee" })}
                >
                  <Image src="/images/icons/chevron_right.svg" svg />
                </div>
              )
            }

          </div>
          <div className="list_block info_block">
            <div className="desc_flex">
              <Image src="/images/icons/receipt.svg" />
              <div className="title_block">
                <p className="title">{invoiceData.type?.name}</p>
                <p className="text"> 發票設定 </p>
              </div>
            </div>
            <div onClick={() => setInvoiceModal(true)}
            >
              <Image src="/images/icons/chevron_right.svg" svg />
            </div>
          </div>
        </div>
      </div>
      <div id="ECPayPayment" className=""></div>
      {paymentRendered && (
        <div className="flex justify-center">
          <button
            className="btn"
            onClick={handleGetPayToken}
            disabled={isClicked}
          >
            {isClicked ? "付款中" : "付款"}
          </button>
        </div>
      )}
      {/* </div> */}
      {
        invoiceModal && (<Invoice invoiceData={invoiceData}
          setInvoiceModal={setInvoiceModal}
          onSubmit={(val) => {
            setInvoiceData(val)
            setInvoiceModal(null)
          }}
        />)
      }
    </div>
  );
}
